import React, {Component} from 'react'
import {SortableHandle} from 'react-sortable-hoc'
import propTypes from 'prop-types'
import {get, has, isNil} from 'lodash'
import IconButton from 'material-ui/IconButton'
import {defaultSizes} from 'theme/sizes'
import theme from 'theme/index'
import Icon, {iconNames} from 'components/icon'
import Actionable from 'components/actionable'
import {parseCssSelector} from 'helpers/css'
import {getPartCategoryActionsMenu} from '../../treeSearcher/utils'

class Node extends Component {

  getIcon = (node, folderIcon, selected, selectedFolderIcon) => {
    if (node.folderIcon) {
      return selected
        ? get(node, 'selectedIcon', selectedFolderIcon)
        : get(node, 'folderIcon', folderIcon)
    }

    return selected
      ? selectedFolderIcon
      : folderIcon
  }

  render() {
    const {
      node,
      selected,
      expanded,
      hasContent,
      showCount,
      customActions,
      onClick,
      onToggleExpand,
      onAdd,
      onRename,
      onDelete,
      isDragPreview,
      isDragPlaceholder,
      dropping,
      folderIcon,
      selectedFolderIcon,
      collapsedIcon,
      expandedIcon,
      sortable,
      addLabel,
      addFolderIcon,
      children,
      selectedNodeRef,
    } = this.props
    let {isActionEnabled} = this.props

    isActionEnabled = isNil(isActionEnabled) ? true : isActionEnabled(node)

    let nodeClass = 'treeView-node'

    const icon = this.getIcon(node, folderIcon, selected, selectedFolderIcon)
    const iconColor = selected ? theme.palette.primary1Color : null

    if (selected) {
      nodeClass += ' treeView-node-selected'
    }

    if (isDragPreview) nodeClass += ' treeView-node-drag-preview'
    if (isDragPlaceholder) nodeClass += ' treeView-node-drag-placeholder'
    if (dropping) nodeClass += ' treeView-node-dropping'
    const expandIcon = []
    let onDoubleClick
    const actions = []

    // Not for root node
    if (node.key !== 0) {
      onDoubleClick = () => onToggleExpand(node.key, !expanded)

      if (hasContent) {
        expandIcon.push(
          <IconButton
            className={'collapse-icon'}
            key={1}
            onClick={(e) => {
              e.stopPropagation()
              onToggleExpand(node.key, !expanded)
            }}>
            <Icon name={expanded ? expandedIcon : collapsedIcon} color='#AAA' size={24}/>
          </IconButton>
        )
      } else if (sortable) {
        const TagHandle = SortableHandle(Icon)
        expandIcon.push(<TagHandle name={iconNames.reorder} key={3} color='#AAA'/>)
      } else {
        expandIcon.push(<div key={2} className='treeView-icon-placeholder'/>)
      }
    }

    if (onAdd && isActionEnabled) {
      actions.push({
        text: addLabel,
        icon: addFolderIcon,
        onClick: (e) => onAdd(e, node.key, this.label),
      })
    }

    if (node.key !== 0 && isActionEnabled) {
      if (onRename) {
        actions.push({
          text: 'Rename',
          icon: theme.icons.edit,
          onClick: (e) => onRename(e, node.key, this.label),
        })
      }

      if (onDelete && isActionEnabled) {
        actions.push({
          text: 'Delete',
          icon: theme.icons.delete,
          onClick: (e) => onDelete(e, node.key),
        })
      }
    }

    let label = node.label
    if (showCount && has(node, 'count')) label += ` (${node.count})`

    const selectedRef = (selected && !isNil(selectedNodeRef)) ? selectedNodeRef : null

    return (
      <Actionable className={parseCssSelector(node.label)} actions={actions} size={defaultSizes.SMALL}>
        <div
          className={nodeClass}
          onClick={() => onClick(node.key)}
          onDoubleClick={onDoubleClick}
          ref={selectedRef}
        >
          <div className={'wrapper'}>
            {expandIcon}
            <Icon name={icon} color={iconColor}/>
            <div
              className='treeView-label'
              ref={t => {
                this.label = t
              }}
            >
              {label}
            </div>
          </div>
          {!isNil(children)
            ? (
              <div className={'children'}>
                {children}
              </div>
            )
            : null
          }
        </div>
        {getPartCategoryActionsMenu(customActions, node, false)}
      </Actionable>
    )
  }
}

Node.propTypes = {
  node: propTypes.object.isRequired,
  children: propTypes.any,
  selected: propTypes.bool.isRequired,
  expanded: propTypes.bool.isRequired,
  hasContent: propTypes.bool.isRequired,
  showCount: propTypes.bool,
  customActions: propTypes.array,
  onClick: propTypes.func.isRequired,
  onToggleExpand: propTypes.func.isRequired,
  addLabel: propTypes.string,
  addFolderIcon: propTypes.string,
  onAdd: propTypes.func,
  onRename: propTypes.func,
  onDelete: propTypes.func,
  sortable: propTypes.bool,
  isDragPreview: propTypes.bool,
  isDragPlaceholder: propTypes.bool,
  folderIcon: propTypes.string.isRequired,
  selectedFolderIcon: propTypes.string.isRequired,
  collapsedIcon: propTypes.string.isRequired,
  expandedIcon: propTypes.string.isRequired,
  dropping: propTypes.bool,
  isActionEnabled: propTypes.func,
  selectedNodeRef: propTypes.object,
}

Node.defaultProps = {
  addLabel: 'Add a Folder',
  addFolderIcon: iconNames.addFolder,
  onToggleExpand: () => {
  },
  isActionEnabled: null,
}


export default Node
